import axios from "axios";

const apiPublic = () => {
  return axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    withCredentials: false,
  });
};

export default apiPublic;
